/* Girl Chocolate, Quiz state machine.
 * Vanilla JS port of Quiz.jsx. 18 steps:
 * 0 intro · 1-14 questions/encouragements · 15 email · 16 loading · 17 results
 * Steps with type=single auto-advance 220ms after a click.
 * Steps with type=multi/scale/email require an explicit Continue.
 * Step 16 (loading animation) auto-advances after 5 seconds.
 * Progress persists to localStorage under QUIZ_KEY.
 */
(function () {
 'use strict';

 var QUIZ_KEY = 'gc_quiz_v1';
 var TOTAL_STEPS = 18;
 // Indices that aren't question screens, for progress math.
 // intro=0, encouragements=3/7, loading=16, results=17. Total questions=12.
 var NON_Q_STEPS = { 0: 1, 3: 1, 7: 1, 15: 1, 16: 1, 17: 1 };
 var TOTAL_QUESTIONS = 12;

 function ready(fn) {
 if (document.readyState !== 'loading') fn();
 else document.addEventListener('DOMContentLoaded', fn);
 }

 function isValidEmail(v) {
 return /\S+@\S+\.\S+/.test(v || '');
 }

 function initQuiz(root) {
 var state = {
 stepIdx: 0,
 answers: {},
 email: '',
 name: '',
 pain: 5
 };

 // Cache step elements once, indexed by step number.
 var stepEls = {};
 var stepNodes = root.querySelectorAll('[data-quiz-step]');
 for (var i = 0; i < stepNodes.length; i++) {
 stepEls[parseInt(stepNodes[i].getAttribute('data-quiz-step'), 10)] = stepNodes[i];
 }

 var topbar = root.querySelector('[data-quiz-topbar]');
 var progressEl = root.querySelector('[data-quiz-progress]');
 var pctEl = root.querySelector('[data-quiz-pct]');
 var loadingTimer = null;

 /* ---------- persistence ---------- */
 function loadSaved() {
 try {
 var saved = JSON.parse(localStorage.getItem(QUIZ_KEY) || '{}');
 if (saved.answers && typeof saved.answers === 'object') state.answers = saved.answers;
 if (typeof saved.email === 'string') state.email = saved.email;
 if (typeof saved.name === 'string') state.name = saved.name;
 if (typeof saved.pain === 'number') state.pain = saved.pain;
 } catch (e) {}
 }
 function saveState() {
 try {
 localStorage.setItem(QUIZ_KEY, JSON.stringify({
 answers: state.answers,
 email: state.email,
 name: state.name,
 pain: state.pain
 }));
 } catch (e) {}
 }

 /* ---------- progress ---------- */
 function computePct() {
 if (state.stepIdx === 0) return 0;
 if (state.stepIdx >= 16) return 100;
 // Count completed question screens before current.
 var completed = 0;
 for (var k = 0; k < state.stepIdx; k++) {
 if (!NON_Q_STEPS[k]) completed++;
 }
 return Math.min(100, Math.round((completed / TOTAL_QUESTIONS) * 100));
 }

 function renderProgress() {
 var pct = computePct();
 var hideTop = state.stepIdx === 0 || state.stepIdx >= 16;
 if (topbar) {
 if (hideTop) topbar.setAttribute('hidden', '');
 else topbar.removeAttribute('hidden');
 }
 if (progressEl) progressEl.style.width = pct + '%';
 if (pctEl) pctEl.textContent = pct + '%';
 }

 /* ---------- loading animation ---------- */
 function startLoadingAnimation() {
 var loadEl = stepEls[16];
 if (!loadEl) return;
 var steps = loadEl.querySelectorAll('[data-load-step]');
 // Stagger the check marks
 for (var i = 0; i < steps.length; i++) {
 (function(step, delay) {
 setTimeout(function() {
 step.classList.add('is-done');
 }, delay);
 })(steps[i], (i + 1) * 1400);
 }
 // Auto advance to results after 5s
 loadingTimer = setTimeout(function() {
 showStep(17);
 }, 5000);
 }

 /* ---------- selection rendering ---------- */
 function renderStepSelection(stepEl) {
 if (!stepEl) return;
 var type = stepEl.getAttribute('data-quiz-type');
 var key = stepEl.getAttribute('data-quiz-key');
 if (type === 'single') {
 var selected = state.answers[key];
 var btns = stepEl.querySelectorAll('[data-quiz-answer]');
 for (var i = 0; i < btns.length; i++) {
 var v = btns[i].getAttribute('data-quiz-answer');
 var is = v === selected;
 btns[i].classList.toggle('is-selected', is);
 var icon = btns[i].querySelector('.gc-quiz__optCheck .material-symbols-rounded');
 if (icon) icon.textContent = is ? 'check_circle' : 'radio_button_unchecked';
 }
 } else if (type === 'multi') {
 var arr = state.answers[key] || [];
 var mbtns = stepEl.querySelectorAll('[data-quiz-answer]');
 for (var j = 0; j < mbtns.length; j++) {
 var mv = mbtns[j].getAttribute('data-quiz-answer');
 var mis = arr.indexOf(mv) >= 0;
 mbtns[j].classList.toggle('is-selected', mis);
 var micon = mbtns[j].querySelector('.gc-quiz__optCheck .material-symbols-rounded');
 if (micon) micon.textContent = mis ? 'check_box' : 'check_box_outline_blank';
 }
 var cont = stepEl.querySelector('[data-quiz-next]');
 if (cont) cont.disabled = arr.length === 0;
 } else if (type === 'scale') {
 var slider = stepEl.querySelector('[data-quiz-scale-input]');
 var num = stepEl.querySelector('[data-quiz-scale-num]');
 if (slider) slider.value = String(state.pain);
 if (num) num.textContent = String(state.pain);
 } else if (type === 'email') {
 var nameInput = stepEl.querySelector('[data-quiz-name-input]');
 var emailInput = stepEl.querySelector('[data-quiz-email-input]');
 var submit = stepEl.querySelector('[data-quiz-submit]');
 if (nameInput) nameInput.value = state.name;
 if (emailInput) emailInput.value = state.email;
 if (submit) submit.disabled = !isValidEmail(state.email);
 }
 }

 /* ---------- step visibility ---------- */
 function showStep(idx) {
 if (loadingTimer) { clearTimeout(loadingTimer); loadingTimer = null; }
 state.stepIdx = idx;
 for (var s in stepEls) {
 if (parseInt(s, 10) === idx) stepEls[s].removeAttribute('hidden');
 else stepEls[s].setAttribute('hidden', '');
 }
 renderProgress();
 renderStepSelection(stepEls[idx]);
 if (idx === 17) renderResults();
 if (idx === 16) startLoadingAnimation();
 // Scroll the panel into view on advance (smooth on mobile).
 if (idx > 0) {
 try { root.scrollIntoView({ behavior: 'smooth', block: 'start' }); } catch (e) {}
 }
 saveState();
 }

 function goNext() { if (state.stepIdx < TOTAL_STEPS - 1) showStep(state.stepIdx + 1); }
 function goPrev() { if (state.stepIdx > 0) showStep(state.stepIdx - 1); }

 /* ---------- recommendation logic ---------- */
 function buildRecommendation() {
 var symptoms = state.answers.symptoms || [];
 var symptomsCount = symptoms.length;
 var isHeavy = state.answers.duration === '8-14'
 || state.answers.duration === 'most'
 || state.pain >= 7
 || state.answers.impact === 'often'
 || state.answers.impact === 'always';
 var plan = (isHeavy || symptomsCount >= 4) ? '3-month' : 'monthly';

 var goal = state.answers.goal;
 var focus = goal === 'all' ? 'full-spectrum cycle support'
 : goal === 'pain' ? 'cramp-first relief'
 : goal === 'mood' ? 'mood-stability focus'
 : goal === 'skin' ? 'skin & hormone balance'
 : goal === 'bloat' ? 'bloat-targeted support'
 : goal === 'energy' ? 'even-energy support'
 : 'cycle support';

 var headline = state.name
 ? (state.name + ", you’re all set.")
 : "You’re all set.";

 return {
 headline: headline,
 plan: plan,
 focus: focus,
 planLabel: plan === '3-month' ? '3-Month Kit' : 'Monthly Kit',
 planPrice: plan === '3-month' ? '$133' : '$93',
 planPer: plan === '3-month' ? ' today, then $83/3 mo' : ' today, then $33/mo',
 planSave: plan === '3-month' ? 'BEST VALUE' : 'SAVE 25%',
 cyclesEst: state.pain >= 7 ? '2-3 cycles' : '1-2 cycles',
 symptomCount: symptomsCount || 4
 };
 }

 function renderResults() {
 var resultsEl = stepEls[17];
 if (!resultsEl) return;
 var r = buildRecommendation();
 var setText = function (sel, txt) {
 var el = resultsEl.querySelector(sel);
 if (el) el.textContent = txt;
 };
 setText('[data-quiz-headline]', r.headline);
 setText('[data-quiz-focus]', r.focus);
 setText('[data-quiz-cycles-est]', r.cyclesEst);
 setText('[data-quiz-plan-save]', r.planSave);
 setText('[data-quiz-plan-label]', r.planLabel);
 setText('[data-quiz-plan-price]', r.planPrice);
 setText('[data-quiz-plan-per]', r.planPer);
 setText('[data-quiz-symptom-count]', String(r.symptomCount));
 setText('[data-quiz-email-echo]', state.email || 'your inbox');
 }

 /* ---------- event delegation ---------- */
 root.addEventListener('click', function (e) {
 var target = e.target;
 var answerBtn = target.closest && target.closest('[data-quiz-answer]');
 var nextBtn = target.closest && target.closest('[data-quiz-next]');
 var prevBtn = target.closest && target.closest('[data-quiz-prev]');

 if (answerBtn && root.contains(answerBtn)) {
 var stepEl = answerBtn.closest('[data-quiz-step]');
 if (!stepEl) return;
 var type = stepEl.getAttribute('data-quiz-type');
 var key = stepEl.getAttribute('data-quiz-key');
 var value = answerBtn.getAttribute('data-quiz-answer');

 if (type === 'single') {
 state.answers[key] = value;
 renderStepSelection(stepEl);
 saveState();
 setTimeout(goNext, 220);
 } else if (type === 'multi') {
 var arr = state.answers[key] || [];
 var idx = arr.indexOf(value);
 if (idx >= 0) arr.splice(idx, 1);
 else arr.push(value);
 state.answers[key] = arr;
 renderStepSelection(stepEl);
 saveState();
 }
 return;
 }

 if (nextBtn && root.contains(nextBtn) && !nextBtn.disabled) {
 goNext();
 return;
 }

 if (prevBtn && root.contains(prevBtn)) {
 goPrev();
 return;
 }
 });

 // Slider
 var slider = root.querySelector('[data-quiz-scale-input]');
 if (slider) {
 slider.addEventListener('input', function (e) {
 var v = parseInt(e.target.value, 10);
 if (isNaN(v)) return;
 state.pain = v;
 var num = root.querySelector('[data-quiz-scale-num]');
 if (num) num.textContent = String(v);
 saveState();
 });
 }

 // Email inputs.
 var nameInput = root.querySelector('[data-quiz-name-input]');
 var emailInput = root.querySelector('[data-quiz-email-input]');
 if (nameInput) {
 nameInput.addEventListener('input', function (e) {
 state.name = e.target.value;
 saveState();
 });
 }
 if (emailInput) {
 emailInput.addEventListener('input', function (e) {
 state.email = e.target.value;
 var submit = root.querySelector('[data-quiz-submit]');
 if (submit) submit.disabled = !isValidEmail(state.email);
 saveState();
 });
 }

 // Email form submission.
 var form = root.querySelector('[data-quiz-email-form]');
 if (form) {
 form.addEventListener('submit', function (e) {
 e.preventDefault();
 if (!isValidEmail(state.email)) return;
 submitEmail();
 });
 }

 function submitEmail() {
 var listId = root.getAttribute('data-quiz-klaviyo-list') || '';
 var payload = {
 email: state.email,
 name: state.name,
 pain: state.pain,
 answers: state.answers
 };
 if (listId) {
 try {
 var body = new URLSearchParams();
 body.append('g', listId);
 body.append('email', state.email);
 if (state.name) body.append('$first_name', state.name);
 fetch('https://manage.kmail-lists.com/ajax/subscriptions/subscribe', {
 method: 'POST',
 mode: 'no-cors',
 headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
 body: body.toString()
 }).catch(function () {});
 } catch (e) {}
 }
 // Generate the personalized PDF report + email it (Cloudflare Worker).
 var reportApi = root.getAttribute('data-quiz-report-api') || '';
 if (reportApi) {
   try {
     var friendlyDate = '';
     try { friendlyDate = new Date().toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' }); } catch (e) {}
     fetch(reportApi.replace(/\/+$/, '') + '/report', {
       method: 'POST',
       headers: { 'Content-Type': 'application/json' },
       body: JSON.stringify({ email: state.email, name: state.name, pain: state.pain, answers: state.answers, date: friendlyDate, productUrl: root.getAttribute('data-quiz-product-url') || '' })
     }).catch(function () {});
   } catch (e) {}
 }
 try {
 window.dispatchEvent(new CustomEvent('gc:quiz-complete', { detail: payload }));
 } catch (e) {}
 goNext(); // -> step 16 (loading animation), which auto-advances to 17 (results)
 }

 /* ---------- init ---------- */
 try { localStorage.removeItem(QUIZ_KEY); } catch (e) {}
 showStep(0);
 }

 ready(function () {
 var roots = document.querySelectorAll('[data-quiz-root]');
 for (var i = 0; i < roots.length; i++) initQuiz(roots[i]);
 });
})();
